// extracted by mini-css-extract-plugin
export default {"container":"L0a7LDOVf9Yj3g6JqhiW"};